import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { VatsError, VatsLoaded, VatsRequested } from './vats.actions';
import { PublicService } from '../../@core/data/public/public.service';

@Injectable()
export class VatsEffects {

  constructor(
    private actions$: Actions,
    private publicService: PublicService,
  ) {}

  requestVats$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VatsRequested),
      mergeMap(() =>
        {
          return this.publicService.getVats().pipe(
            map((res: any) => {
              return VatsLoaded({ vatsInfo: res })
            }),
            catchError((error: any) => of(VatsError()))
          ) 
        }
      )
    )
  );

  onError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(VatsError),
        tap(() => {
        })
      ),
    { dispatch: false }
  );
}
